import { getTimeOutDate } from '@helpers/FormalOffers/getTimeOutDate';
import { ConfettiSVG } from '@svgComponents/confettiSVG/ConfettiSVG';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { MoneyNoDecimals } from '../../../../../ui/moneyNoDecimals';
import { FormalOffer } from '../../../../MyOffers.types';

export const ApprovalHeader = ({
    approvalStatusTimeOut,
    maxCashAmount
}: {
    approvalStatusTimeOut: ReturnType<typeof getTimeOutDate>;
    maxCashAmount: FormalOffer['max_amount'];
}) => (
    <div
        className="rounded-s bg-secondary-95 p-xl"
        data-testid="approval-header"
    >
        <div className="flex items-center gap-l">
            <ConfettiSVG className="hidden shrink-0 min-sm:block" />
            <p className="m-0 text-2xl font-bold">
                <FormattedMessage
                    id="_.approval_header.heading"
                    defaultMessage="You’re <strong>approved</strong> for {offeredAmount}"
                    values={{
                        offeredAmount: (
                            <MoneyNoDecimals value={maxCashAmount} />
                        ),
                        strong: (chunks) => (
                            <strong className="text-success-drk">
                                {chunks}
                            </strong>
                        )
                    }}
                />
            </p>
        </div>

        <p className="mb-0 mt-s text-l font-reg">
            <FormattedMessage
                id="_.approval_header.subHeading"
                defaultMessage="These funds will be available until {timeoutDate}. After that you will need to reapply."
                values={{
                    timeoutDate: (
                        <span className="font-bold">
                            <FormattedDate
                                value={new Date(approvalStatusTimeOut)}
                                day="2-digit"
                                month="long"
                                year="numeric"
                            />
                        </span>
                    )
                }}
            />
        </p>
    </div>
);
